import requestCtxs from '@/sealFilter/requestCtxs'


//查看图片信息
export function queryimgebyId (data) {
    return requestCtxs({
        url: '/whgs/api/queryimgebyId',
        method: 'post',
        data
    })
}

// 查询视频是否启用
export function queryWebSet(data) {
    return requestCtxs({
        url: '/whgs/api/queryWebSet',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/bannerImg.js